<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'displayName', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/EventAttributeKeys/queries/eventAttributeKeys.gql')
      }"
      :headers="$options.headersConfig"
      :filters="{
        displayName: { control: 'text', modifier: 'contains' },
        type: {
          control: 'select',
          options: [
            {
              value: 'STRING',
              text: 'STRING'
            },
            {
              value: 'NUMERIC',
              text: 'NUMERIC'
            },
            {
              value: 'DATETIME',
              text: 'DATETIME'
            },
            {
              value: 'BOOLEAN',
              text: 'BOOLEAN'
            },
            {
              value: 'FILE',
              text: 'FILE'
            }
          ]
        },
        name: { control: 'text', modifier: 'contains' },
        createdAt: { control: 'date-range' }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          item-key="name"
          v-model="mixSelectedItems"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <!-- <span v-on="on">{{
                  $t(`page-attributes.header-titles.${h.value}`)
                }}</span> -->

                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value], 0) }}
              </div>
              <div v-else-if="h.text === 'Отображаемое имя'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-attribute',
                    params: { name: item.name }
                  }"
                  >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'actions'">
                <router-link
                  :to="{
                    name: 'page-attribute',
                    params: { name: item.name }
                  }"
                  title="Редактировать"
                  ><v-btn icon><v-icon>mdi-pencil</v-icon></v-btn></router-link
                >
                <a title="Удалить">
                  <v-btn icon @click="deleteAttr(item.name)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirmEventRemoving" confirmText="Удалить" />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import { formatAmount } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import DeleteAttribute from '@/services/gql/types/EventAttributeKey/mutations/deleteEventAttributeKey.gql'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'

export default {
  name: 'GridAttributes',
  gridType: 'eventAttributes',
  perPage,
  headersConfig,
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  components: {
    DataTableWrapper,
    DataTableFilters,
    ConfirmationDialog,
    DateTimeCell
  },
  mixins: [gridDependentMixin],
  data () {
    return {
      queryState: null
    }
  },
  methods: {
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    formatAmount,
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    async deleteAttr (name) {
      try {
        await this.$refs.confirmEventRemoving.open()
        await this.$async.deleteAttr.$perform({ name })
        this.$successMsg('Атрибут удален')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении атрибута ${name}`)
      }
    }
  },
  async: {
    deleteAttr (variables) {
      return this.$apollo.mutate({
        mutation: DeleteAttribute,
        variables
      })
    },
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
